import type {SearchCriteriaRaw} from '../../../types';
import {createCheckoutsRule} from '../checkoutsRule';
import type {CheckoutsRule, TSearchTypeCheckouts} from '../types';

export type RawCheckoutsSearchCriteria =
	SearchCriteriaRaw<TSearchTypeCheckouts>;

export const rawCheckoutsCriteriaToRuleObject = (
	criteria: RawCheckoutsSearchCriteria,
): CheckoutsRule<any> => {
	return createCheckoutsRule({
		type: criteria.subtype1,
		userId: parseInt(criteria.value1) || 0,
	});
};

export default rawCheckoutsCriteriaToRuleObject;
